import clsx from 'clsx';
import BrandLogo from '../BrandLogo';
import ModuleIcon from './ModuleIcon';

const SHORT_NAMES = {
  conversations: 'Conversations',
  'secure-drop': 'Secure Drop',
  sign: 'Sign',
  flow: 'Flow',
};

/**
 * The MyDocUploads logo followed by the module the visitor is using, so a
 * recipient sees "MyDocUploads | Sign" rather than a bare logo. Pages that are
 * plain MyDocUploads (shares, file requests) keep using BrandLogo alone.
 */
export default function ServiceBrand({ module, size = 'md', logoTo = '/', className }) {
  const big = size === 'lg';
  return (
    <div className={clsx('flex min-w-0 items-center', big ? 'gap-3' : 'gap-2.5', className)}>
      <BrandLogo className={big ? 'h-10 w-auto' : 'h-8 w-auto'} to={logoTo} />
      <span aria-hidden="true" className={clsx('w-px bg-slate-300', big ? 'h-9' : 'h-7')} />
      <span className="flex shrink-0 items-center gap-1.5">
        <ModuleIcon slug={module} decorative className={big ? 'h-8 w-8' : 'h-7 w-7'} />
        <span className={clsx('font-semibold text-slate-800', big ? 'text-lg' : 'text-base')}>
          {SHORT_NAMES[module]}
        </span>
      </span>
    </div>
  );
}
